<template>
  <div>
    <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
    <div class="row">
        <div class="col-md-12">
            <div class="top-list-small-toolbar">
                <div>
                  <h4 class="text-primary">Laporan Komisi Sales</h4>
                  <div class="form-inline ml-auto mb-auto">
                    <div class="button-group">
                      <!-- <span><b>Company:</b> </span> -->
                      <select v-model="company_no" class="btn btn-sm btn-soft-outline-primary">
                        <option value="">-- All --</option>
                        <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                      </select>
                    </div>
                    <div class="button-group ml-1">
                      <!-- <span class="mr-1"><b>Date:</b> </span> -->
                      <date-picker v-model="startDate" type="date" range placeholder="Select date range"></date-picker>
                    </div>
                    <button type="button" class="btn btn-sm  btn-hard-primary ml-1" @click="refreshList">
                      <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                    </button>
                  </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row" style="margin-top: 100px">
      <div class="col-md-3">
        <div class="card report-card">
          <div class="card-body">
            <div class="float-right">
              <i class="dripicons-user-group report-main-icon"></i>
            </div>
            <h5><span class="badge badge-success">Total Payment</span></h5>
            <h3 class="my-3">
              <span v-if="loadingSales === false">
                <div class="loadingio-spinner-bars-km984sg9h2">
                  <div class="ldio-m41ff6uvz8">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </span>
              <span v-else>
                {{ totalPayment | currency }}
              </span>
            </h3>
          </div>
          <!--end card-body-->
        </div>
        <!--end card-->
      </div>
      <!-- totalKomisi -->
      <div class="col-md-3">
        <div class="card report-card">
          <div class="card-body">
            <div class="float-right">
              <i class="dripicons-user-group report-main-icon"></i>
            </div>
            <h5><span class="badge badge-info">Total Komisi</span></h5>
            <h3 class="my-3">
              <span v-if="loadingSales === false">
                <div class="loadingio-spinner-bars-km984sg9h2">
                  <div class="ldio-m41ff6uvz8">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </span>
              <span v-else>
                {{ totalKomisi | currency }}
              </span>
            </h3>
          </div>
          <!--end card-body-->
        </div>
        <!--end card-->
      </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-body">
                    <div v-for="d in dataRaw" :key="d.employee_no">
                        <div class="text-center mt-5">
                          <h5><b>{{ d.name }} - {{ d.employee_no }}</b></h5>
                        </div>
                        <hr>
                        <div class="table-responsive">
                            <table class="table table-item mb-0 table-sm table-hover table-striped">
                                <thead>
                                    <th>Status</th>
                                    <th>Sale No.</th>
                                    <th>Date</th>
                                    <th>Due Date</th>
                                    <th>Payment Date</th>
                                    <th>Age</th>
                                    <th>Customer</th>
                                    <th>Subtotal</th>
                                    <th>Discount</th>
                                    <th>Tax</th>
                                    <th>Total</th>
                                    <th>Total Payment</th>
                                    <th>Komisi</th>
                                    <th>Type</th>
                                    <th>%</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(s, index) in d.sales" :key="index">
                                        <td>
                                          <span class="badge badge-danger" v-if="s.status === 'out'">{{ s.status }}</span>
                                          <span class="badge badge-success" v-else>{{ s.status }}</span>
                                        </td>
                                        <td>{{ s.sale_no }}</td>
                                        <td>{{ s.sale_date | dateFormat('DD/MM/YYYY') }}</td>
                                        <td>{{ s.sale_due_date | dateFormat('DD/MM/YYYY') }}</td>
                                        <td>{{ s.payment_date | dateFormat('DD/MM/YYYY') }}</td>
                                        <td>{{ Math.round(s.sale_age) }}</td>
                                        <td>{{ s.customer_no }}</td>
                                        <td>{{ s.subtotal | currency }}</td>
                                        <td>{{ s.discount | currency }}</td>
                                        <td>{{ s.tax | currency }}</td>
                                        <td class="text-right">{{ s.total | currency }}</td>
                                        <td class="text-right">{{ s.total_payment | currency }}</td>
                                        <td class="text-right">{{ s.sale_commission_amount | currency }}</td>
                                        <td>
                                          <span class="badge badge-primary" v-if="s.sale_commission_type === 'salesman'">{{ s.sale_commission_type }}</span>
                                          <span class="badge badge-secondary" v-else>{{ s.sale_commission_type }}</span>
                                        </td>
                                        <td>
                                            <span v-if="s.sale_commission_percentage > 0"><b>{{ s.sale_commission_percentage }}</b></span>
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                  <td colspan="10"></td>
                                  <td class="text-right"><b>{{ d.total_sales | currency }}</b></td>
                                  <td class="text-right"><b>{{ d.total_payment | currency }}</b></td>
                                  <td class="text-right"><b>{{ d.total_komisi | currency }}</b></td>
                                  <td></td>
                                  <td></td>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <pre>{{ dataRaw }}</pre> -->
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import DatePicker from 'vue2-datepicker'
import 'vue-loading-overlay/dist/vue-loading.css'
import Axios from 'axios'
import { getHeader, salesUrl } from '@/config'
import { mapState } from 'vuex'

export default {
  name: 'SaleReportKomisiList',
  components: {
    Loading,
    DatePicker
  },
  data () {
    var date = new Date()
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      loadingSales: true,
      company_no: '',
      dataRaw: [],
      startDate: [date1, date2],
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      }
    }
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      companyList: state => state.companies.companyList
    }),
    totalSales () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var sales = array[i].sales
        for (let z = 0; z < sales.length; z++) {
          sum += parseFloat(sales[z].total)
        }
      }
      return sum
    },
    totalKomisi () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var sales = array[i].sales
        for (let z = 0; z < sales.length; z++) {
          if (sales[z].sale_commission_amount !== null) {
            sum += parseFloat(sales[z].sale_commission_amount)
          }
        }
      }
      return sum
    },
    totalPayment () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var sales = array[i].sales
        for (let z = 0; z < sales.length; z++) {
          sum += parseFloat(sales[z].total_payment)
        }
      }
      return sum
    },
    totalCOGS () {
      var sum = 0
      var array = this.groupData
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].totalCost)
      }
      return sum
    },
    totalProfitPlus () {
      var sum = 0
      var array = this.groupData
      for (let i = 0; i < array.length; i++) {
        if (array[i].totalProfit >= 0) {
          sum += Math.abs(parseFloat(array[i].totalProfit))
        }
      }
      return sum
    },
    totalProfitMinus () {
      var sum = 0
      var array = this.groupData
      for (let i = 0; i < array.length; i++) {
        if (array[i].totalProfit < 0) {
          sum += Math.abs(parseFloat(array[i].totalProfit))
        }
      }
      return sum
    },
    totalProfit () {
      var sum = 0
      var array = this.groupData
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].totalProfit)
      }
      return sum
    },
    groupData () {
      var result = []
      if (this.dataRaw.length > 0) {
        this.dataRaw.reduce(function (res, value) {
          var key = value.product_no
          var sales = parseFloat(value.total_sales) * parseFloat(value.qty)
          var cost = parseFloat(value.total_cost)
          var retur = parseFloat(value.total_retur)
          var profit = sales - retur - cost
          if (!res[key]) {
            res[key] = {
              product_no: value.product_no,
              product: value.description,
              uom_id: value.uom_id,
              qty: value.qty,
              totalSales: Math.round(sales),
              totalCost: Math.round(cost),
              totalProfit: Math.round(profit),
              totalRetur: Math.round(retur)
            }
            result.push(res[key])
          } else {
            res[key].qty = Math.round(parseFloat(res[key].qty) + parseFloat(value.qty))
            res[key].totalSales = Math.round(parseFloat(res[key].totalSales) + sales)
            res[key].totalCost = Math.round(parseFloat(res[key].totalCost) + cost)
            res[key].totalRetur = Math.round(parseFloat(res[key].totalRetur) + retur)
            res[key].totalProfit = Math.round(parseFloat(res[key].totalProfit) + profit)
          }
          return res
        }, {})
      }
      // return result
      var col = 'totalProfit'
      var ascending = false
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return result.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      })
    },
    begin () {
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      return begin
    },
    end () {
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      return end
    },
    companyData () {
      var obj = {
        name: 'Ashahy',
        address: null,
        phone: null
      }
      const cmp = this.companyList.find(d => d.company_no === this.company_no)
      if (cmp) {
        obj = {
          name: cmp.name,
          address: cmp.address,
          phone: cmp.phone
        }
      }
      return obj
    }
  },
  methods: {
    async refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        begin: begin,
        end: end,
        company_no: this.company_no
      }
      console.log(obj)
      console.log(salesUrl + '/report-komisi')
      await Axios.post(salesUrl + '/report-komisi', obj, { headers: getHeader() })
        .then(response => {
          this.dataRaw = response.data.data
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$Progress.finish()
          this.loader.isLoading = false
          this.$swal('Report', error.response.data.message, 'error')
          throw error
        })
    }
  }
}
</script>
